<template>
  <v-container id="notascursada-ivt">
    <v-row class="text-center">
      <v-col cols="12">
        <v-card class="alineacentro DatosMatriculado">
          <v-card-title class="DatosMatriculado">
            <v-row class="text-center">
              <v-col cols="12">
                <v-card
                  dark
                  color="success"
                  class="alineacentro DatosMatriculado"
                >
                  <strong>NOTA DE CURSADA</strong>
                </v-card>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col>
                <v-spacer />
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="12" md="9" lg="9">
                <v-select
                  v-model="filtros.idcarrera"
                  :items="listacarreras"
                  label="Carrera"
                  item-text="carreracompleta"
                  item-value="idcarrera"
                  height="20px"
                  v-on:change="Listar"
                />
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <v-select
                  v-model="filtros.anio"
                  :items="listaanios"
                  label="Año"
                  item-text="anio"
                  item-value="anio"
                  height="20px"
                  v-on:change="Listar"
                  class="ocupa30"
                />
              </v-col>
            </v-row>
            <v-row class="text-center" v-if="listacarreras.length>0 && listacarreras.filter(c=> c.idcarrera===filtros.idcarrera)[0].idnivel===4">
              <v-col cols="12" md="9" lg="9">
                <v-select
                  v-model="filtros.idsede"
                  :items="listasedes"
                  label="Sede"
                  item-text="sede"
                  item-value="idsede"
                  no-data-text="Sin Sedes"
                  height="20px"
                  v-on:change="Listar"
                />
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <v-btn
                  class="ma-2"
                  x-small
                  color="blue"
                  title="Listar Cursadas"
                  @click="Listar"
                >
                  <v-icon dark> mdi-magnify</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="text-center" v-if="listacarreras.length>0 && listacarreras.filter(c=> c.idcarrera===filtros.idcarrera)[0].idnivel===4">
              <v-col cols="12">
                <v-data-table
                  :headers="columnas"
                  :items="lista"
                  :items-per-page="lista.length"
                  hide-default-footer
                  item-key="idcatedra"
                  class="elevation-1"
                  dense
                  no-data-text="Sin Registros"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          color="green"
                          @click="EditarNotas(item)"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!item.permiteeditarnotas"
                        >
                          <v-icon>mdi-format-list-numbered-rtl</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar Notas</span>
                    </v-tooltip>
                    &nbsp;
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          color="blue"
                          @click="CerrarNotas(item)"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!item.permitecerrarnotas"
                        >
                          <v-icon>mdi-door-closed-lock</v-icon>
                        </v-btn>
                      </template>
                      <span>Cerrar Cursada</span>
                    </v-tooltip>
                    &nbsp;
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          color="blue"
                          @click="AprobarNotas(item)"
                          v-bind="attrs"
                          v-on="on"
                          v-if="item.permiteaprobarnotas"
                        >
                          <v-icon>mdi-door-closed-lock</v-icon>
                        </v-btn>
                      </template>
                      <span>Aprobar Cursada</span>
                    </v-tooltip>
                    &nbsp;
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          color="yellow"
                          @click="ImprimirActaCierre(item)"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!item.permiteimprimirplanillanotas"
                        >
                          <v-icon>mdi-printer</v-icon>
                        </v-btn>
                      </template>
                      <span>Imprimir Acta Cierre</span>
                    </v-tooltip>
                    &nbsp;
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          color="yellow"
                          @click="ImprimirPlanillaNotas(item)"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!item.permiteimprimirplanillanotas"
                        >
                          <v-icon>mdi-printer</v-icon>
                        </v-btn>
                      </template>
                      <span>Imprimir Planilla Notas</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:item.estadonotascursada="{ item }">
                    <v-chip :color="getcolorestadocatedra(item.idestadonotascursada)" dark>
                      <p class="textofilagrilla">{{ item.estadonotascursada }}</p>
                    </v-chip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogerroresvalida" persistent max-width="900">
      <v-card>
        <v-card-title class="headline">
          Errores de Validación
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="dialogerroresvalida = false">Cerrar</v-btn>
        </v-card-actions>
        <v-card-text>
          <v-data-table
            :headers="columnaserrores"
            :items="listaerrores"
            :items-per-page="listaerrores.length"
            hide-default-footer
            item-key="nro"
            class="elevation-1"
            dense
            no-data-text="Sin Registros"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogmensaje" persistent max-width="350">
      <v-card>
        <v-card-title class="headline">
          {{ mensajetitulo }}
        </v-card-title>
        <v-card-text>
          {{ mensajecuerpo }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="dialogmensaje = false;if (mensajehome === true) {$router.push('Home');}"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loading" full-width>
      <v-container
        fluid
        class="full-height"
        style="background-color: rgba(255, 255, 255, 0.5)"
      >
        <v-row
          align="center"
          justify="center"
          style="height: 100vh"
          no-gutters
          dense
        >
          <v-col class="elementocentrado">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
    <v-dialog v-model="dialogeditanotas" persistent full-width>
      <v-card>
        <v-card-title class="headline">
          {{ dialogeditanotastitulo }}
        </v-card-title>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="alineaderecha">
              <v-btn v-if="listaerrores.length>0" color="red darken-1" text @click="vererroresvalida">
                Ver Errores
              </v-btn>
              <v-spacer v-if="listaerrores.length>0"></v-spacer>
              <v-btn color="green darken-1" text @click="guardarnotas">
                Guardar
              </v-btn>
              <v-btn color="red darken-1" text @click="dialogeditanotas = false">
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
          <br />
          <br />
        </v-card-actions>
        <v-card-text>
          <br />
          <br />
          <v-row class="text-center">
            <v-col cols="12">
              <p><strong style="color: black">0 - AUSENTE</strong> -- <strong style="color: red">1-5 DESAPROBADO</strong> -- <strong style="color: green">6-10 APROBADO</strong></p>
            </v-col>
          </v-row>
          <v-row class="text-center">
            <v-col cols="12">
              <v-data-table
                :headers="columnasdetalle"
                :items="edited.detalles"
                :item-class="itemRowBackground"
              >
                <template v-slot:item.notanumericaparcial1="{ item, index }">
                  <v-text-field
                    v-model="item.notanumericaparcial1"
                    label="P1"
                    height="20px"
                    type="number"
                    :ref="'inputp1-' + index"
                    :rules="[rulesnotas.rango]"
                    @keydown="validarEntero"
                    @keydown.enter="focusNextp1(index)"
                    @input="saveEditNota(item)"
                  />
                </template>
                <template v-slot:item.notanumericaparcial2="{ item, index }">
                  <v-text-field
                    v-model="item.notanumericaparcial2"
                    label="P2"
                    height="20px"
                    type="number"
                    :ref="'inputp2-' + index"
                    :rules="[rulesnotas.rango]"
                    @keydown="validarEntero"
                    @keydown.enter="focusNextp2(index)"
                    @input="saveEditNota(item)"
                  />
                </template>
                <template v-slot:item.notanumericarecuperatorio="{ item, index }">
                  <v-text-field
                    v-model="item.notanumericarecuperatorio"
                    label="Rec"
                    height="20px"
                    type="number"
                    :ref="'inputrec-' + index"
                    :rules="[rulesnotas.rango]"
                    @keydown="validarEntero"
                    @keydown.enter="focusNextrec(index)"
                    @input="saveEditNota(item)"
                  />
                </template>
                <template v-slot:item.aprobo="{ item }">
                  <v-simple-checkbox
                    v-model="item.aprobo"
                    @changed="controlaregistro(item,'aprobo')"
                    disabled
                  ></v-simple-checkbox>
                </template>
                <template v-slot:item.aprobointegrador="{ item }">
                  <v-simple-checkbox
                    v-model="item.aprobointegrador"
                    disabled
                  ></v-simple-checkbox>
                </template>
                <template v-slot:item.promocion="{ item }">
                  <v-simple-checkbox
                    v-model="item.promocion"
                    :disabled="(item.notanumericarecuperatorio!=null && item.notanumericarecuperatorio!='' && item.notanumericarecuperatorio!=-1) || item.notanumericaparcial1<8 || item.notanumericaparcial2<8"
                    @changed="controlaregistro(item,'promo')"
                  ></v-simple-checkbox>
                </template>
                <template v-slot:item.notanumericapromocion="{ item, index }">
                  <v-text-field
                    v-model="item.notanumericapromocion"
                    label="Promo"
                    height="20px"
                    type="number"
                    :ref="'inputprom-' + index"
                    :rules="[rulesnotas.rangoprom]"
                    v-if="item.promocion && item.idestado===1 && !item.aprobointegrador"
                    @keydown="validarEntero"
                    @input="saveEditNota(item)"
                  />
                </template>
                <template v-slot:item.estado="{ item }">
                  <v-select
                    v-model="item.idestado"
                    :items="listaestadoscursada"
                    label="Estado"
                    item-text="estado"
                    item-value="idestado"
                    no-data-text="Sin Estados"
                    solo
                    height="15px"
                    v-on:change="selecionaestadocursada(item)"
                    :disabled= "item.aprobointegrador || (item.idestado===4 && roles.includes(2))"
                  />
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ConfirmDlg ref="confirm" />
  </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
export default {
  name: "notascursadav2",
  components: {
    ConfirmDlg: ConfirmDlg
  },
  data() {
    return {
      loading: false,
      usuario: '',
      permisolectura: false,
      permisoescritura: false,
      idrol: 0,
      roles: [],
      nromodulo: 30,
      dialogmensaje: false,
      mensajetitulo: '',
      mensajecuerpo: '',
      mensajehome: false,
      columnas: [
        {
          text: "Op.",
          value: "actions",
          width: 220
        },
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idcatedra",
          width: 70
        },
        {
          text: "Ciclo",
          align: "center",
          sortable: true,
          value: "ciclo",
          width: 85
        },
        {
          text: "Cod",
          align: "center",
          sortable: true,
          value: "codigoasignatura",
          width: 80
        },
        {
          text: "Asignatura",
          align: "center",
          sortable: true,
          value: "asignatura",
          width: 200
        },
        {
          text: "Div",
          align: "center",
          sortable: true,
          value: "division",
          width: 80
        },
        {
          text: "Docente",
          align: "center",
          sortable: true,
          value: "docente",
          width: 180
        },
        {
          text: "Tipo",
          align: "center",
          sortable: true,
          value: "temporalidad",
          width: 90
        },
        {
          text: "Cuat",
          align: "center",
          sortable: true,
          value: "tiempo",
          width: 85
        },
        {
          text: "Alu",
          align: "center",
          sortable: true,
          value: "cantidadalumnos",
          width: 75
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estadonotascursada",
          width: 110
        }
      ],
      lista: [],
      listacarreras: [],
      listaanios: [],
      filtros: {
        idcarrera: 0,
        anio: 0,
        idsede: 0
      },
      listasedes: [],
      dialogeditanotas: false,
      dialogeditanotastitulo: '',
      estadodetalle: false,
      estadodetalleColor: '',
      estadodetalleText: '',
      columnasdetalle: [
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idcursada",
          width: 70
        },
        {
          text: "Apellido",
          align: "center",
          sortable: true,
          value: "apellido",
          width: 110
        },
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "nombre",
          width: 110
        },
        {
          text: "DNI",
          align: "center",
          sortable: true,
          value: "nrodoc",
          width: 90
        },
        {
          text: "Asist",
          align: "center",
          sortable: true,
          value: "asistencia",
          width: 90
        },
        {
          text: "Parc 1",
          align: "center",
          sortable: true,
          value: "notanumericaparcial1",
          width: 90
        },
        {
          text: "Parc 2",
          align: "center",
          sortable: true,
          value: "notanumericaparcial2",
          width: 90
        },
        {
          text: "Recup",
          align: "center",
          sortable: true,
          value: "notanumericarecuperatorio",
          width: 90
        },
        {
          text: "Aprobó",
          align: "center",
          sortable: true,
          value: "aprobo",
          width: 90
        },
        {
          text: "Integrador",
          align: "center",
          sortable: true,
          value: "aprobointegrador",
          width: 105
        },
        {
          text: "Promoción",
          align: "center",
          sortable: true,
          value: "promocion",
          width: 110
        },
        {
          text: "Nota Promo",
          align: "center",
          sortable: true,
          value: "notanumericapromocion",
          width: 115
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estado",
          width: 110
        },
      ],
      edited: {
        idcatedra: 0,
        idcarrera: 0,
        anio: 0,
        idsede: 0,
        idasignatura: 0,
        iddivision: 0,
        detalles: [],
        usuario: ''
      },
      listaestadoscursada: [],
      listaerrores: [],
      columnaserrores: [
        {
          text: "Nro",
          align: "center",
          sortable: true,
          value: "nro",
          width: 70
        },
        {
          text: "ID Cur",
          align: "center",
          sortable: true,
          value: "idcursada",
          width: 80
        },
        /* {
          text: "Estudiante",
          align: "center",
          sortable: true,
          value: "apenom",
          width: 150
        }, */
        {
          text: "Error",
          align: "center",
          sortable: true,
          value: "error",
          width: 400
        }
      ],
      dialogerroresvalida: false,
      rulesnotas: {
        rango: value => {
          if(value!=null && value!=''){
            const val = parseInt(value);
            return (val >= 0 && val <= 10) || 'La Nota debe estar entre 1 y 10';
          }else{
            return true;
          }
        },
        rangoprom: value => {
          if(value!=null && value!=''){
            const val = parseInt(value);
            return (val >= 8 && val <= 10) || 'La Nota debe estar entre 8 y 10';
          }else{
            return true;
          }
        },
      },
    };
  },
  mounted() {
    this.loading = true;
    this.roles=[];
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    var rolesuser = localStorage.getItem("rolesuserid").split(',');
    rolesuser.forEach((elemento) => {
        this.roles.push(parseInt(elemento));
    });
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
    if (existeper.length === 0) {
      this.loading = false;
      this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
      this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 2).length > 0 ? true : false;
      this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 3).length > 0 ? true : false;
      if(this.roles.includes(2)) {
        this.filtros.iddocente= parseInt(localStorage.getItem("idpersona"));
      }else{
        this.filtros.iddocente= 0;
      }
      var i=0;
      var anioactual= (new Date()).getFullYear();
      for(i=2024;i<=anioactual;i++) {
        this.listaanios.push({anio: i});
      }
      this.filtros.anio= (new Date()).getFullYear();
      var parametroscarrera= JSON.stringify({iddocente: this.filtros.iddocente});
      axios.post("referenciales/PostCarreras",parametroscarrera, { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          this.listacarreras = result.data.datos.filter(c=> c.idnivel===4);
          this.filtros.idcarrera= this.listacarreras.length>0 ? this.listacarreras[0].idcarrera : 0;
          if(this.listacarreras.length>0) {
            this.listasedes=[];
            for(i=0;i<=this.listacarreras.length-1;i++){
              if(this.listasedes.filter(s=> s.idsede===this.listacarreras[i].idsede).length===0){
                this.listasedes.push({idsede: this.listacarreras[i].idsede, sede: this.listacarreras[i].sede});
              }
            }
            this.filtros.idsede=this.listacarreras[0].idsede;
            //this.loading = false;
          }
          //else{
            //this.loading = false;
          //}
          axios.get("referenciales/estadodetallecursada").then((result) => {
            if(result.data.resultado===0) {
              this.listaestadoscursada = result.data.datos;
              this.loading=false;
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje('Error', error, false);
          });
        }else{
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    Listar () {
      this.loading = true;
      var parametros= JSON.stringify({idcarrera: this.filtros.idcarrera, anio: this.filtros.anio, idsede: this.filtros.idsede, usuario: this.usuario});
      axios.post('cursada/PostListaCursadaParaNota',parametros, { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          this.lista = result.data.datos;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
      });
    },
    getcolorestadocatedra (estado) {
      if (estado === 1) {return "grey";}
      else if (estado === 2) {return "#A67DF3";}
      else if (estado === 3) {return "green";}
      else if (estado === 4) {return "blue";}
      else if (estado === 5) {return "orange";}
    },
    EditarNotas (item) {
      this.loading = true;
      this.edited.idcatedra= item.idcatedra;
      this.edited.idcarrera= item.idcarrera;
      this.edited.anio= item.anio;
      this.edited.idsede= item.idsede;
      this.edited.idasignatura= item.idasignatura;
      this.edited.iddivision= item.iddivision;
      this.edited.usuario= this.usuario;
      var parametros= JSON.stringify({idcatedra: item.idcatedra, usuario: this.usuario});
      axios.post('cursada/PostTraeDetalleCursadaParaNota',parametros, { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          this.edited.detalles = result.data.datos;
          this.dialogeditanotas= true;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
      });
    },
    async CerrarNotas (item) {
      if (await this.$refs.confirm.open('Confirmar','Esta seguro de querer cerrar la edición de notas de la cursada?')) {
        this.loading=true;
        const cursada = JSON.stringify({idcatedra: item.idcatedra, usuario: this.usuario});
        axios.post("cursada/PostCerrarCursada", cursada, { headers: {"Content-Type": "application/json", }}).then((result) => {
          if (result.data.resultado === 0) {
            this.Listar();
          }else{
            this.loading = false;
            this.listaerrores= result.data.datos[0];
            //this.MostrarMensaje("Error", result.data.resultadomensaje, false);
            this.dialogerroresvalida= true;
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }
    },
    async AprobarNotas (item) {
        if (await this.$refs.confirm.open('Confirmar','Esta seguro de querer aprobar el resultado de la cursada?')) {
        this.loading=true;
        const cursada = JSON.stringify({idcatedra: item.idcatedra, usuario: this.usuario});
        axios.post("cursada/PostAprobarCursada", cursada, { headers: {"Content-Type": "application/json", }}).then((result) => {
          if (result.data.resultado === 0) {
            this.Listar();
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }
    },
    ImprimirActaCierre (item) {
      this.loading = true;
      axios.post("reportes/GetReporte", {idreporte: 14, formato: 'PDF',nromodulo: this.nromodulo, usuario: this.usuario, listaparametros: [{ orden: 1, nombre: "idcatedra", valor: item.idcatedra.toString()},{ orden: 2, nombre: "usuario", valor: this.usuario} ] },{ headers: { "Content-Type": "application/json" }})
        .then((result) => {
          this.loading = false;
          if (result.data.toString().startsWith("Error") === false) {
            window.open(result.data, "_blank");
          } else {
            this.MostrarMensaje("Error", result.data, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    ImprimirPlanillaNotas (item) {
      this.loading = true;
      axios.post("reportes/GetReporte", {idreporte: 15, formato: 'PDF',nromodulo: this.nromodulo, usuario: this.usuario, listaparametros: [{ orden: 1, nombre: "idcatedra", valor: item.idcatedra.toString()},{ orden: 2, nombre: "usuario", valor: this.usuario} ] },{ headers: { "Content-Type": "application/json" }})
        .then((result) => {
          this.loading = false;
          if (result.data.toString().startsWith("Error") === false) {
            window.open(result.data, "_blank");
          } else {
            this.MostrarMensaje("Error", result.data, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    guardarnotas () {
      this.loading=true;
      this.controlanotas();
      var notas= JSON.stringify(this.edited);
      //console.log(notas);
      axios.post("cursada/PostNotasCursada",notas, { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          this.dialogeditanotas=false;
          this.Listar();
        }else{
          this.loading = false;
          this.listaerrores= result.data.datos[0];
          this.MostrarMensaje('Error', 'Existen errores de validación, presione el botón ver errores para visualizar los mismos.', false);
        }
      }).catch((error) => {
        this.loading = false;
        console.log(error);
        this.MostrarMensaje('Error', error, false);
      });
    },
    controlanotas () {
      var i=0;
      for(i=0;i<this.edited.detalles.length;i++) {
        this.edited.detalles[i].notanumericaparcial1= this.edited.detalles[i].notanumericaparcial1!=null && this.edited.detalles[i].notanumericaparcial1.toString()!='' && parseFloat(this.edited.detalles[i].notanumericaparcial1)!=-1 ? parseFloat(this.edited.detalles[i].notanumericaparcial1.toString().replace(",", ".")) : -1;
        this.edited.detalles[i].notanumericaparcial2= this.edited.detalles[i].notanumericaparcial2!=null && this.edited.detalles[i].notanumericaparcial2.toString()!='' && parseFloat(this.edited.detalles[i].notanumericaparcial2)!=-1 ? parseFloat(this.edited.detalles[i].notanumericaparcial2.toString().replace(",", ".")) : -1;
        this.edited.detalles[i].notanumericarecuperatorio= this.edited.detalles[i].notanumericarecuperatorio!=null && this.edited.detalles[i].notanumericarecuperatorio.toString()!='' && parseFloat(this.edited.detalles[i].notanumericarecuperatorio)!=-1 ? parseFloat(this.edited.detalles[i].notanumericarecuperatorio.toString().replace(",", ".")) : -1;
        this.edited.detalles[i].notanumericapromocion= this.edited.detalles[i].notanumericapromocion!=null && this.edited.detalles[i].notanumericapromocion.toString()!='' && parseFloat(this.edited.detalles[i].notanumericapromocion)!=-1 ? parseFloat(this.edited.detalles[i].notanumericapromocion.toString().replace(",", ".")) : -1;
      }
    },
    vererroresvalida () {
      this.dialogerroresvalida=true;
    },
    saveEditNota (item) {
      var res= this.controlaregistro(item);
      if(res==='')
      {
        // item.notanumericaparcial1= item.notanumericaparcial1!=null && item.notanumericaparcial1!='' && parseFloat(item.notanumericaparcial1)!=-1 ? parseFloat(item.notanumericaparcial1) : -1;
        // item.notanumericaparcial2= item.notanumericaparcial2!=null && item.notanumericaparcial2!='' && parseFloat(item.notanumericaparcial2)!=-1 ? parseFloat(item.notanumericaparcial2) : -1;
        // item.notanumericarecuperatorio= item.notanumericarecuperatorio!=null && item.notanumericarecuperatorio!='' && parseFloat(item.notanumericarecuperatorio)!=-1 ? parseFloat(item.notanumericarecuperatorio) : -1;
        //item.notanumericapromocion= item.notanumericapromocion!=null ? parseFloat(item.notanumericapromocion) : '';
        item.observacion= item.observacion!=null ? item.observacion : '';
        // this.estadodetalle = true
        // this.estadodetalleColor = 'success'
        // this.estadodetalleText = 'Dato Guardado!'
      }else{
        this.MostrarMensaje('Error', res, false);
        return false;
      }
    },
    cancelEditNota () {
      this.estadodetalle = true
      this.estadodetalleColor = 'error'
      this.estadodetalleText = 'Cancelado'
    },
    openEditNota () {
      //this.snack = true
      //this.snackColor = 'info'
      //this.snackText = 'Dialog opened'
    },
    closeEditNota () {
      //console.log('Dialog closed')
    },
    controlaregistro (item) {
      var res='';
      var aprueba= true;
      var promociona= true;
      if(item.idestado===1) {
        if(item.notanumericaparcial1!=null && item.notanumericaparcial1!='' && item.notanumericaparcial1!=-1) {
          if(parseFloat(item.notanumericaparcial1)!=0) {
            if (parseFloat(item.notanumericaparcial1)>=6) {
              aprueba= true;
            }else{
              aprueba= false;
            }
          }else{
            aprueba= false;
            promociona= false;
          }
        }

        if(item.notanumericaparcial2!=null && item.notanumericaparcial2!='' && item.notanumericaparcial2!=-1) {
            if(parseFloat(item.notanumericaparcial2)!=0) {
              if (parseFloat(item.notanumericaparcial2)>=6 && parseFloat(item.notanumericaparcial1)>=6) {
                aprueba= true;
              }else{
                aprueba= false;
                promociona= false;
              }
            }else{
              aprueba= false;
              promociona= false;
            }
        }

        if(aprueba===true) {
          if(item.notanumericarecuperatorio!=null && item.notanumericarecuperatorio!='' && item.notanumericarecuperatorio!=-1) {
            res='No puede colocar nota de recuperatorio si los parciales los tiene aprobados!!!';
            item.notanumericarecuperatorio= -1;
          }

          if (parseFloat(item.notanumericaparcial1)>=8 && parseFloat(item.notanumericaparcial2)>=8) {
            promociona= true;
          }else{
            promociona= false;
          }
        }else{
          promociona= false;
          if(item.notanumericarecuperatorio!=null && item.notanumericarecuperatorio!='' && item.notanumericarecuperatorio!=-1) {
            if(parseFloat(item.notanumericarecuperatorio)>=6) {
              aprueba= true;
            }
          }
        }

        item.aprobo= aprueba;
        item.promocion= promociona;

        if(promociona && (item.notanumericapromocion===null || item.notanumericapromocion==='' || item.notanumericapromocion===-1)) {
          var suma= (parseFloat(item.notanumericaparcial1)+parseFloat(item.notanumericaparcial2!=null && item.notanumericaparcial2!=''&& item.notanumericaparcial2!=-1 ? item.notanumericaparcial2 : 0));
          if(suma>0) {
            item.notanumericapromocion= parseFloat(suma/2);
          }else{
            item.notanumericapromocion= -1;
          }
        }
      }

      return res;
    },
    isNumber(n) {
      return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
    },
    selecionaestadocursada (item) {
      if(item.idestado===2){
        item.aprobo=false;
        item.promocion= false;
        item.notanumericapromocion= '';
      }else if (item.idestado===3) {
        item.promocion= false;
        item.notanumericapromocion= '';
      }
    },
    itemRowBackground (item) {
      if (item.idestado === 1) {return "background-color: white";}
      else if (item.idestado === 2) {return "background-color: orange";}
      else if (item.idestado === 3) {return "background-color: red";}
      //return item.idestado >1 ? 'style-1' : 'style-2'
    },
    getcolornota (nota) {
      if (nota === '' || nota===-1) {return "background-color: white";}
      else if (nota === 0) {return "background-color: grey";}
      else if (nota>= 1 && nota<= 5) {return "background-color: red";}
      else if (nota>=6 && nota<= 10) {return "background-color: green";}
    },
    getcolornotapromo (nota) {
      if (nota === '' || nota===-1) {return "background-color: white";}
      else if (nota>= 8) {return "background-color: blue";}
    },
    focusNextp1(currentIndex) {
      //const nextIndex = currentIndex + 1
      const nextRef = this.$refs['inputp2-' + currentIndex]
      if (nextRef && nextRef.focus) {
        nextRef.focus()
      }
    },
    focusNextp2(currentIndex) {
      //const nextIndex = currentIndex + 1
      const nextRef = this.$refs['inputrec-' + currentIndex]
      if (nextRef && nextRef.focus) {
        nextRef.focus()
      }
    },
    focusNextrec(currentIndex) {
      const nextIndex = currentIndex + 1
      const nextRef = this.$refs['inputp1-' + nextIndex]
      if (nextRef && nextRef.focus) {
        nextRef.focus()
      }
    },
    validarEntero(e) {
      /* // Bloquea punto (.), coma (,), letra e, signo menos (-) y signo mas (+)
      if (['.',',','e','-','+'].includes(e.key)) {
        e.preventDefault();
      } */

      // Bloquea coma (,), letra e, signo menos (-) y signo mas (+)
      if (['e','-','+'].includes(e.key)) {
        e.preventDefault();
      }
    },
},
  computed: {
    fechalocalfecha: function () {
      if (this.edited.fecha != null && this.edited.fecha != "") {
        var fecha = new Date(this.edited.fecha);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
  },
};
</script>
<style>
.style-1 {
  background-color: rgb(215,215,44)
}
.style-2 {
  background-color: rgb(114,114,67)
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}

.titulodialog {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
}

.textofilagrilla {
  font-size: 0.680rem !important;
  height: 5px !important;
}

.v-application--is-ltr .v-banner--is-mobile .v-banner__wrapper {
    padding-left: 1px !important;
}

.v-banner--is-mobile .v-banner__wrapper {
    flex-wrap: wrap;
    padding-top: 1px !important;
}

.v-application--is-ltr .v-banner__wrapper {
    padding: 1px 1px 1px 1px !important;
}

.letraroja {
  color: red;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
</style>
